import {Box, Skeleton} from '@mui/material';

import {ProfileComparisonProfileGridSkeleton} from './ProfileComparisonProfileGridSkeleton';
import {profileComparisonSectionCardSx} from './profileComparisonSectionStyles';
import {EmpionPaper} from '../../../../../components/EmpionPaper/EmpionPaper';

export const ProfileComparisonSectionSkeleton = () => (
  <Box data-testid='profile-comparison-section-skeleton'>
    <Box sx={{mt: 2.5, mb: 2}}>
      <Box sx={{display: 'flex', alignItems: 'center', gap: 1, mb: 0.5}}>
        <Skeleton variant='circular' width={22} height={22} />
        <Skeleton variant='text' width={220} height={28} />
      </Box>
      <Skeleton variant='text' width='70%' height={18} />
    </Box>
    <ProfileComparisonProfileGridSkeleton />
    <EmpionPaper sx={profileComparisonSectionCardSx}>
      <Skeleton variant='rounded' height={40} sx={{borderRadius: '8px'}} />
    </EmpionPaper>
  </Box>
);
